
export const GenderDisplay = {
  '0': 'Nữ',
  '1': 'Nam',
  '2': 'GTK'
};